export const arrayToOptions = function (data) {
  const options = {}
  data.forEach((item) => {
    options[item.value] = item.display
  })

  return options
}

export const getHeaderHeight = () => {
  const header = document.getElementsByClassName('site-header-container')[0]
  if (import.meta.client) {
    return header ? header.clientHeight : 0
  } else {
    return 130
  }
}

export function removeDomain(url) {
  try {
    const parsedUrl = new URL(url)
    return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash
  } catch {
    return url // Return original if invalid URL
  }
}
